import axios from 'axios';

const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class VaccineTemplateService {
	async getVaccineTemplates(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(API_URL + `/Poultry/VaccineTemplate`, {
				headers: headers,
			});

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getSuppliers(authToken, type) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(API_URL + `/Products/Supplier/${type}/Type`, {
				headers: headers,
			});

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getVaccineTemplateById(authToken, id) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL + `/Poultry/VaccineTemplate/${id}`,
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getProducts(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Products/SearchAndSort`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addVaccineTemplate(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Poultry/VaccineTemplate`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async addVaccine(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL +
					`/Poultry/VaccineTemplate/${request_data.id}/VaccineTemplateProduct`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
}

export default new VaccineTemplateService();
